import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 text-left mt-4">
                <h1>    </h1> 
                <p className="mb-0">
                
                </p>
                <a href="#features" className="btn btn-custom btn-lg page-scroll" style={{ marginBottom: "5rem" }} >
                  Descubre más
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
